const langCode = process.env.GATSBY_LANG_CODE;

const translation = langCode ? require(`../../i18n/${langCode}.json`) : null;

exports._ = (s) => {
  if (langCode !== undefined && translation?.[s] === undefined) {
    console.warn(`Missing translation: '${s}'`);
  }
  return translation?.[s] || s;
};
